<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'HistoricalRevenueGraph',
  extends: Bar,
  props: {
    historicalRevenue: {
      type: Array,
      default: () => [],
    },
    tasof: {
      type: String,
      default: () => '',
    }
  },

  data () {
    return {
      graphData: {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: '#97C131',
          maxBarThickness: 30,
        }],
      },
      graphOptions: {
        plugins: {
          labels: {
            render: ({ value }) => {
              return `${this.$options.filters.currency(value)}`
            },
            position: 'outside',
            textMargin: 5,
            fontFamily: "Sansation",
            fontSize: 10,
          },
        },
        layout: {
            padding: {
                top: 10
            }
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawTicks: false,
              drawOnChartArea: false,
            },
            ticks: {
              padding: 10,
              maxRotation: 0,
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              display: false,
              min: 0,
              callback: value => this.$options.filters.currency(value),
            },
          }],
        },
        tooltips: {
          enabled: false,
        },
      },
    }
  },

  watch: {
    historicalRevenue: {
      handler: () =>  { this.formatData() },
      deep: true,
    },
  },

  mounted () {
    this.formatData()
  },

  methods: {
    formatData () {
      const revenues = this.historicalRevenue.slice()
        .sort(({ year: a }, { year: b }) => a - b)

      this.graphData.labels = revenues.map(({ year }) => year)
      this.graphData.datasets[0].data = revenues.map(({ revenue }) => revenue)

      const date = new Date(this.tasof);
      if (this.tasof) {
        this.graphData.labels[this.graphData.labels.length - 1] = 'T12*'
      }
      this.renderChart(this.graphData, this.graphOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/HistoricalRevenueGraph.vue